import { render, staticRenderFns } from "./CarePairingView.vue?vue&type=template&id=5b23bd34&scoped=true&"
import script from "./CarePairingView.vue?vue&type=script&lang=js&"
export * from "./CarePairingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b23bd34",
  null
  
)

export default component.exports